import { Object3D } from "three";
import { BatchedRenderer, QuarksUtil } from "three.quarks";
import { GameResourcesPackage } from "../../../../resources/GameResourcesPackage";
import { clone } from "three/examples/jsm/utils/SkeletonUtils.js";

export class ClickClodsParticle extends Object3D {
    private effect: Object3D;

    public constructor(
        private readonly gameResources: GameResourcesPackage,
        private readonly batchRenderer: BatchedRenderer
    ) {
        super();
    }

    public play(): void {
        this.effect = clone(this.gameResources.assets_game_particles_click_clods_thjson);
        QuarksUtil.setAutoDestroy(this.effect, true);
        QuarksUtil.addToBatchRenderer(this.effect, this.batchRenderer);
        QuarksUtil.play(this.effect);
        this.add(this.effect);
    }

    public destroy(): void {
        this.remove(this.effect);
    }
}
